import VicServiceLogo from '@service-victoria/component-library/components/Icons/VicServiceLogo';
import { Body } from '@service-victoria/component-library/components/Text/Body';
import colors from '@service-victoria/component-library/utils/colors';
import device from '@service-victoria/component-library/utils/device';
import styled, { css } from 'styled-components';

import Container from '../Container';

export const ContentWrapper = styled(Container)<{ hasBanner?: boolean }>`
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 150px); // 150px derived from the header height

  @media ${device.isDesktop} {
    min-height: calc(100vh - 242px); // 242px is derived from the height of the header + padding

    ${({ hasBanner }) =>
      hasBanner &&
      `
        box-shadow: 0 2px 4px -2px rgba(0, 0, 0, 0.4), 0 2px 13px 0px rgba(0, 0, 0, 0.1);
        position: relative;
        top: -50px;
      `}
  }
`;

export const ContentContainer = styled.main<{ noContentPadding?: boolean }>`
  flex: 1 1 auto;
  background-color: ${colors.white};

  ${({ noContentPadding }) => {
    if (!noContentPadding) {
      return css`
        padding: 20px;

        @media ${device.isDesktop} {
          padding: 42px 50px;
        }
      `;
    }
  }}
`;

export const ContentFooterContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 96px;
  border-top: solid 2px ${colors.darkGrey10};
  background-color: ${colors.white};
`;

export const ContentFooterLogo = styled(VicServiceLogo)`
  height: 64px;
  margin-right: 16px;
`;

export const ContentFooterTextContainer = styled.div``;
export const ContentFooterText = styled(Body)`
  margin: 0;
`;
export const ContentFooterServiceVictoriaText = styled(ContentFooterText)`
  font-weight: 600;
  font-size: 18px;
`;
